import { useMutation, useQuery } from "react-query";
import { GET, POST } from "../../Services";
import { notification } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  LogrosEditar,
  LogrosForm,
} from "../../Pages/Admin/Mantenedores/Logros/Logros";
import {
  CodigosPokemonEditar,
  CodigosPokemonForm,
} from "../../Pages/Admin/Mantenedores/CodigosPokemon/CodigosPokemon";
import {
  CodigosSobresEditar,
  CodigosSobresForm,
} from "../../Pages/Admin/Mantenedores/CodigosSobres/CodigosSobres";
import {
  ZonasEditar,
  ZonasForm,
} from "../../Pages/Admin/Mantenedores/Zonas/Zonas";
import {
  RequerimientoEvolucionEditar,
  RequerimientoEvolucionForm,
} from "../../Pages/Admin/Mantenedores/RequerimientoEvoluciones/RequerimientoEvolucion";
import {
  EstadoMovimientoEditar,
  EstadoMovimientoForm,
} from "../../Pages/Admin/Mantenedores/EstadosMovimiento/EstadosMovimiento";
import {
  RolesEditar,
  RolesForm,
} from "../../Pages/Admin/Mantenedores/Roles/Roles";
import { ListarUsuarios } from "../../Pages/Admin/Usuarios/TabList/ListarUsuarios";
import { DataUsuario } from "../../Pages/Admin/Usuarios/TabList/DataUsuario";
import { ObjetosUsuarios } from "../../Pages/Admin/Usuarios/TabList/ObjetosUsuarios";
import { PokemonesUsuario } from "../../Pages/Admin/Usuarios/TabList/PokemonesUsuario";
import { LogrosUsuario } from "../../Pages/Admin/Usuarios/TabList/LogrosUsuario";
import { PokedexUsuario } from "../../Pages/Admin/Usuarios/TabList/PokedexUsuario";
import { ObjetosEditar } from "../../Pages/Admin/Mantenedores/Objetos/Objetos";
import { TipoImagenEditar } from "../../Pages/Admin/Mantenedores/TipoImagen/TipoImagen";
import { PokemonesCodigos } from "../../Pages/Admin/Codigos/Pokemon/Pokemon";
import { ObjetosCodigos } from "../../Pages/Admin/Codigos/Objetos/Objetos";
import { Gacha } from "../../Pages/Admin/Codigos/Gacha/Gacha";
import { ListarPokemon } from '../../Pages/Admin/Pokemon/TabList/ListarPokemon';
import { DataPokemon } from "../../Pages/Admin/Pokemon/TabList/DataPokemon";
import { ImagenesPokemon } from "../../Pages/Admin/Pokemon/TabList/ImagenesPokemon";
import { RequerimientoEvolucion } from "../../Pages/Admin/Pokemon/TabList/RequerimientoEvolucion";
import { HistoricoGachapon } from "../../Pages/Admin/Codigos/Gacha/HistoricoGachapon";

//APIS listar
export const useListarLogros = (params = null) => {
  return useQuery(
    ["listarLogros", params],
    async () => {
      const response = await GET(
        "logros/listarLogros",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response?.data) {
        throw new Error("Error al listar logros");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar logros",
        });
      },
    }
  );
};

export const useListarZonas = (params = null) => {
  return useQuery(
    ["listarZonas", params],
    async () => {
      const response = await GET(
        "zonas/listarZonas",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response?.data) {
        throw new Error("Error al listar zonas");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar zonas",
        });
      },
    }
  );
};

export const useListarRequerimientosEvolucion = (params = null) => {
  return useQuery(
    ["listarRequerimientosEvolucion", params],
    async () => {
      const response = await GET(
        "requerimientosEvolucion/listarRequerimientosEvolucion",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response?.data) {
        throw new Error("Error al listar requerimientos de evolución");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar requerimientos de evolución",
        });
      },
    }
  );
};

export const useListarEstadosMovimiento = (params = null) => {
  return useQuery(
    ["listarEstadosMovimiento", params],
    async () => {
      const response = await GET(
        "estadoMovimiento/listarEstadosMovimiento",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response?.data) {
        throw new Error("Error al listar estados de movimiento");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar estados de movimiento",
        });
      },
    }
  );
};

export const useListarRoles = (params = null) => {
  return useQuery(
    ["listarRoles", params],
    async () => {
      const response = await GET(
        "rol/listarRoles",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response?.data) {
        throw new Error("Error al listar roles");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar roles",
        });
      },
    }
  );
};

export const useRolesSelect = (params = null) => {
  return useQuery(
    ["rolesSelect", params],
    async () => {
      const response = await GET(
        "rol/rolesSelect",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.error) {
        throw new Error("Error al listar tipos de usuario.");
      }

      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
      },
    }
  );
};

export const useTipoUsuarioSelect = (params = null) => {
  return useQuery(
    ["tipoUsuarioSelect", params],
    async () => {
      const response = await GET(
        "usuarios/tipoUsuarioSelect",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.error) {
        throw new Error("Error al listar tipos de usuario.");
      }

      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
      },
    }
  );
};

export const useListarPokemones = (params = null) => {
  return useQuery(
    ["listarPokemonTable", params],
    async () => {
      const response = await GET(
        "pokemon/listarPokemonTable",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar pokemones");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar pokemones",
        });
      },
    }
  );
};

export const useListarCodigosPokemones = (params = null) => {
  return useQuery(
    ["selectCodigoPokemon", params],
    async () => {
      const response = await GET(
        "pokemon/selectCodigoPokemon",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar codigos");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar codigos",
        });
      },
    }
  );
};

export const useListarObjetos = (params = null) => {
  return useQuery(
    ["listarObjetos", params],
    async () => {
      const response = await GET(
        "objeto/selectObjetos",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar objetos");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar objetos",
        });
      },
    }
  );
};

export const useListarObjetosTabla = (params = null) => {
  return useQuery(
    ["listarObjetos", params],
    async () => {
      const response = await GET(
        "objeto/listarObjetos",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar objetos");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar objetos",
        });
      },
    }
  );
};

export const useListarGrados = (params = null) => {
  return useQuery(
    ["listarGrados", params],
    async () => {
      const response = await GET(
        "objeto/selectGrados",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar grados");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar grados",
        });
      },
    }
  );
};

export const useListarUsuariosTable = (params = null) => {
  return useQuery(
    ["listarUsuariosTable", params],
    async () => {
      const response = await GET(
        "usuarios/listarUsuariosTable",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response?.data) {
        throw new Error("Error al listar usuarios");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar usuarios",
        });
      },
    }
  );
};

export const useDetalleUsuario = (params = null) => {
  return useQuery(
    ["detalleDataUsuario", params],
    async () => {
      const response = await GET(
        "usuarios/detalleDataUsuario",
        `?${new URLSearchParams(params).toString()}`
      );
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al buscar la data del usuario",
        });
      },
    }
  );
};

export const usePokemonesUsuarioTable = (params = null) => {
  return useQuery(
    ["pokemonesUsuarioTable", params],
    async () => {
      const response = await GET(
        "usuarios/pokemonesUsuarioTable",
        `?${new URLSearchParams(params).toString()}`
      );
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al buscar la data del usuario",
        });
      },
    }
  );
};

export const useSelectUsuarios = (params = null) => {
  return useQuery(
    ["selectUsuarios", params],
    async () => {
      const response = await GET(
        "usuarios/selectUsuarios",
        `?${new URLSearchParams(params).toString()}`
      );

      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar usuarios",
        });
      },
    }
  );
};

//APIS CREAR
export const useCrearLogro = () => {
  return useMutation(async (data) => await POST(data, "logros/crearLogro"), {
    onSuccess: () => {
      notification["success"]({ message: "Logro ingresado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar ingresar logro" });
      }
    },
  });
};

export const useCrearZona = () => {
  return useMutation(async (data) => await POST(data, "zonas/crearZona"), {
    onSuccess: () => {
      notification["success"]({ message: "Zona ingresada correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar ingresar zona" });
      }
    },
  });
};
export const useCrearRequerimientoEvolucion = () => {
  return useMutation(
    async (data) =>
      await POST(data, "requerimientosEvolucion/crearRequerimientoEvolucion"),
    {
      onSuccess: () => {
        notification["success"]({
          message: "Requerimiento de evolución ingresado correctamente",
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({
            message: "Error al intentar ingresar requerimiento de evolución",
          });
        }
      },
    }
  );
};
export const useCrearEstadoMovimiento = () => {
  return useMutation(
    async (data) => await POST(data, "estadosMovimiento/crearEstadoMovimiento"),
    {
      onSuccess: () => {
        notification["success"]({
          message: "Estado movimiento ingresado correctamente",
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({
            message: "Error al intentar ingresar Estado movimiento",
          });
        }
      },
    }
  );
};
export const useCrearRol = () => {
  return useMutation(async (data) => await POST(data, "rol/crearRol"), {
    onSuccess: () => {
      notification["success"]({ message: "Rol ingresado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar ingresar rol" });
      }
    },
  });
};

export const useCrearObjeto = () => {
  return useMutation(async (data) => await POST(data, "objeto/crearObjeto"), {
    onSuccess: () => {
      notification["success"]({ message: "Objeto ingresado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar ingresar objeto" });
      }
    },
  });
};

export const useCrearCodigoPokemon = () => {
  return useMutation(
    async (data) => await POST(data, "pokemon/crearCodigosMasivos"),
    {
      onSuccess: () => {
        notification["success"]({
          message: "Códigos ingresados correctamente",
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({
            message: "Error al intentar ingresar Código",
          });
        }
      },
    }
  );
};

export const useCrearCodigoSobres = () => {
  return useMutation(async (data) => await POST(data, "objeto/crearSobre"), {
    onSuccess: () => {
      notification["success"]({ message: "Códigos ingresados correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar ingresar Código" });
      }
    },
  });
};

export const useListarCodigos = (params = null) => {
  return useQuery(
    ["listarCodigos", params],
    async () => {
      const response = await GET(
        "listarCodigos",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar códigos");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar códigos",
        });
      },
    }
  );
};

export const useCrearUsuario = () => {
  return useMutation(
    async (data) => await POST(data, "usuarios/crearUsuario"),
    {
      onSuccess: () => {
        notification["success"]({
          message: "Usuario creado correctamente",
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({
            message: "Error en la creación de usuario.",
          });
        }
      },
    }
  );
};

export const useListarCodigosPokemon = (params = null) => {
  return useQuery(
    ["listarCodigosPokemon", params],
    async () => {
      const response = await GET(
        "listarCodigosPokemon",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar códigos");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar códigos",
        });
      },
    }
  );
};

//APIS editar
export const useEditarLogro = () => {
  return useMutation(async (data) => await POST(data, "logros/editarLogro"), {
    onSuccess: () => {
      notification["success"]({ message: "Logro editado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar editar logro" });
      }
    },
  });
};

export const useEditarZona = () => {
  return useMutation(async (data) => await POST(data, "zonas/editarZona"), {
    onSuccess: () => {
      notification["success"]({ message: "Zona editada correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar editar zona" });
      }
    },
  });
};

export const useEditarRequerimientoEvolucion = () => {
  return useMutation(
    async (data) =>
      await POST(data, "requerimientosEvolucion/editarRequerimientoEvolucion"),
    {
      onSuccess: () => {
        notification["success"]({
          message: "Requerimiento de evolución editado correctamente",
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({
            message: "Error al intentar editar Requerimiento de evolución",
          });
        }
      },
    }
  );
};

export const useEditarEstadoMovimiento = () => {
  return useMutation(
    async (data) =>
      await POST(data, "estadosMovimiento/editarEstadoMovimiento"),
    {
      onSuccess: () => {
        notification["success"]({
          message: "Estado de movimiento editado correctamente",
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({
            message: "Error al intentar editar estado de movimiento",
          });
        }
      },
    }
  );
};

export const useEditarRol = () => {
  return useMutation(async (data) => await POST(data, "rol/editarRol"), {
    onSuccess: () => {
      notification["success"]({ message: "Rol editado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar editar Rol" });
      }
    },
  });
};

export const useEditarObjeto = () => {
  return useMutation(async (data) => await POST(data, "objeto/editarObjeto"), {
    onSuccess: () => {
      notification["success"]({ message: "Objeto editado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar editar objeto" });
      }
    },
  });
};

export const useTransferirPokemon = () => {
  return useMutation(
    async (data) =>
      await POST(data, "pokemon/transferirPokemon"),
    {
      onSuccess: () => {
        notification["success"]({
          message: "Pokémon transferido correctamente",
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({
            message: "Error al intentar transferir Pokémon",
          });
        }
      },
    }
  );
};

export const useGetFormulario = ({ key }) => {
  const formularios = useMemo(
    () => ({
      Logros: <LogrosForm />,
      RequerimientosEvoluciones: <RequerimientoEvolucionForm />,
      EstadosMovimiento: <EstadoMovimientoForm />,
      Roles: <RolesForm />,
      CodigosPokemon: <CodigosPokemonForm />,
      CodigosSobres: <CodigosSobresForm />,
    }),
    []
  );

  const [formularioActive, setFormularioActive] = useState(
    formularios["Logros"]
  );

  useEffect(() => {
    if (key) {
      setFormularioActive(formularios[key]);
    }
  }, [formularios, key]);

  return formularioActive;
};

export const useGetTable = ({ key }) => {
  const tables = useMemo(
    () => ({
      Logros: <LogrosEditar />,
      RequerimientosEvoluciones: <RequerimientoEvolucionEditar />,
      EstadosMovimiento: <EstadoMovimientoEditar />,
      Roles: <RolesEditar />,
      Objetos: <ObjetosEditar />,
      TipoImagen: <TipoImagenEditar />,
    }),
    []
  );
  const [tableActive, setTableActive] = useState(tables["Logros"]);

  useEffect(() => {
    if (key) {
      setTableActive(tables[key]);
    }
  }, [tables, key]);

  return tableActive;
};

export const useGetTableCodigos = ({ key }) => {
  const tables = useMemo(
    () => ({
      "codigos-pokemon": <PokemonesCodigos />,
      "codigos-objetos": <ObjetosCodigos />,
      "codigos-gacha": <Gacha />,
      "historico-gachapon": <HistoricoGachapon />,
    }),
    []
  );
  const [tableActive, setTableActive] = useState(tables["codigos-pokemon"]);

  useEffect(() => {
    if (key) {
      setTableActive(tables[key]);
    }
  }, [tables, key]);

  return tableActive;
};

export const useAdminUsuarios = ({ setKey, activeTabKey }) => {
  const tabs = useMemo(
    () => ({
      lista: () => <ListarUsuarios setActiveKey={setKey} />,
      data: () => <DataUsuario />,
      pokemones: () => <PokemonesUsuario />,
      objetos: () => <ObjetosUsuarios />,
      logros: () => activeTabKey === "logros" ? <LogrosUsuario /> : null,
      pokedex: () => activeTabKey === "pokedex" ? <PokedexUsuario /> : null,
    }),
    [setKey, activeTabKey]
  );

  return tabs;
};

// HOOK PARA ADMINISTRAR POKEMON
export const useAdminPokemon = ({ setKey }) => {
  const [selectedPokemon, setSelectedPokemon] = useState(null);

  const moveTab = useCallback((pokemon) => {
    setKey && setKey("data");
    setSelectedPokemon(pokemon);
  }, [setKey]);

  const goToImagenes = useCallback(() => {
    setKey && setKey("imagenes");
  }, [setKey]);

  const tabs = useMemo(() => ({
    lista: <ListarPokemon moveTab={moveTab} />,
    data: <DataPokemon id={selectedPokemon?.id} onGoToImagenes={goToImagenes} />,
    imagenes: <ImagenesPokemon id={selectedPokemon?.id} />,
    requerimiento: <RequerimientoEvolucion id={selectedPokemon?.id} />,
  }), [moveTab, goToImagenes, selectedPokemon?.id]);

  return tabs;
};

// HOOKS CRUD POKEMON
export const useCrearPokemon = () => {
  return useMutation(async (data) => await POST(data, "pokemon/crearPokemon"), {
    onSuccess: () => notification["success"]({ message: "Pokémon creado correctamente" }),
    onError: (error) => notification["error"]({ message: "Error al crear Pokémon" }),
  });
};

export const useListarTipoImagen = (params = null) => {
  return useQuery(
    ["listarTipoImagen", params],
    async () => {
      const response = await GET(
        "tipoImagen/listarTiposImagen",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response?.data) {
        throw new Error("Error al listar listarTipoImagen");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar listarTipoImagen",
        });
      },
    }
  );
};

export const useCrearTipoImagen = () => {
  return useMutation(async (data) => await POST(data, "tipoImagen/crearTipoImagen"), {
    onSuccess: () => {
      notification["success"]({ message: "Tipo Imagen ingresado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar ingresar Tipo Imagen" });
      }
    },
  });
};

export const useEditarTipoImagen = () => {
  return useMutation(async (data) => await POST(data, "tipoImagen/editarTipoImagen"), {
    onSuccess: () => {
      notification["success"]({ message: "TipoImagen editado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar editar TipoImagen" });
      }
    },
  });
};


export const useListarCuponesPokemones = (params = null) => {
  return useQuery(
    ["listarCodigosPokemon", params],
    async () => {
      const response = await GET(
        "listarCodigosPokemon",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar Codigos pokemones");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar Codigos pokemones",
        });
      },
    }
  );
};

export const useDesactivarCodigoPokemon = () => {
  return useMutation(async (data) => await POST(data, "desactivarCodigoPokemon"), {
    onSuccess: () => {
      notification["success"]({ message: "Codigo Desactivado" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar Desactivar Codigo" });
      }
    },
  });
};



export const useCrarCodigosPokemon = () => {
  return useMutation(async (data) => await POST(data, "pokemon/crearCodigosMasivos"), {
    onSuccess: () => {
      notification["success"]({ message: "Codigos Creados" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar Crear Codigos" });
      }
    },
  });
};


export const useListarCodigosObjetos = (params = null) => {
  return useQuery(
    ["listarCodigos", params],
    async () => {
      const response = await GET(
        "listarCodigos",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar Codigos Objetos");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar Codigos Objetos",
        });
      },
    }
  );
};

export const useCrarCodigosSobres = () => {
  return useMutation(async (data) => await POST(data, "objeto/crearSobre"), {
    onSuccess: () => {
      notification["success"]({ message: "Codigos Creados" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar Crear Codigos" });
      }
    },
  });
};

export const useCrarGachapon = () => {
  return useMutation(async (data) => await POST(data, "gachapon/crearGachapon"), {
    onSuccess: () => {
      notification["success"]({ message: "Gachapon Creados" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar Crear Gachapon" });
      }
    },
  });
};

export const useListarGachapon = (params = null) => {
  return useQuery(
    ["listarGachapon", params],
    async () => {
      const response = await GET(
        "gachapon/gachaponTable",
        `?${new URLSearchParams(params).toString()}`
      );
      if (response.length == 0) {
        throw new Error("Error al listar Gachapon");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar Gachapon",
        });
      },
    }
  );
};

export const useEditarPokemonesGacha = () => {
  return useMutation(async (data) => await POST(data, "gachapon/editarPokemonGacha"), {
    onSuccess: () => {
      notification["success"]({ message: "Gachapon Editado" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al intentar Gachapon Editado" });
      }
    },
  });
};

export const useDataPokemon = (idPokemon) => {
  return useQuery(
    ["dataPokemon", idPokemon],
    async () => {
      if (!idPokemon) return null;
      const response = await GET(
        "pokemon/dataPokemon",
        `?idPokemon=${idPokemon}`
      );
      return response;
    },
    {
      enabled: !!idPokemon,
      onError: (error) => {
        notification["error"]({
          message: "Error al obtener datos del Pokémon",
        });
      },
    }
  );
};

export const useListarHistoricoGachapon = (params = null) => {
  return useQuery(
    ["listarHistoricoGachapon", params],
    async () => {
      const response = await GET(
        "gachapon/logGachaponTable",
        params ? `?${new URLSearchParams(params).toString()}` : ""
      );
      if (!response?.data) {
        throw new Error("Error al listar histórico de gachapon");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al obtener datos del Pokémon",
        });
      },
    }
  );
};

export const useListarPokemonesGachaponTier = () => {
  return useMutation(async (idGacha) => {
    if (!idGacha) return [];
    const response = await GET(
      "gachapon/pokemonGachamonTier",
      `?idGacha=${idGacha}`
    );
    return response || [];
  });
};

export const useSelectPokemon = (params = null) => {
  return useQuery(
    ["selectPokemon", params],
    async () => {
      const response = await GET(
        "pokemon/selectPokemon",
        params ? `?${new URLSearchParams(params).toString()}` : ""
      );
      return response || [];
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar todos los pokemones",
        });
      },
    }
  );
};

export const useSelectLogro = (params = null) => {
  return useQuery(
    ["selectLogro", params],
    async () => {
      const response = await GET(
        "logros/selectLogrosAdmin",
        params ? `?${new URLSearchParams(params).toString()}` : ""
      );
      return response || [];
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar todos los logros",
        });
      },
    }
  );
};

// ============= PERMISOS =============
export const useListarPermisos = (params = null) => {
  return useQuery(
    ["listarPermisos", params],
    async () => {
      const response = await GET(
        "permiso/listarPermisos",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response?.data) {
        throw new Error("Error al listar permisos");
      }
      return response;
    },
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: () => {
        notification["error"]({ message: "Error al intentar listar permisos" });
      },
    }
  );
};

export const useTodosLosPermisos = () => {
  return useQuery(
    ["todosLosPermisos"],
    async () => {
      const response = await GET("permiso/todosLosPermisos", "");
      return response?.datos ?? response ?? [];
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
      onError: () => {
        notification["error"]({ message: "Error al obtener permisos" });
      },
    }
  );
};

export const usePermisosDeRol = (rolId) => {
  return useQuery(
    ["permisosDeRol", rolId],
    async () => {
      const response = await GET("permiso/permisosDeRol", `?rol_id=${rolId}`);
      return response?.datos ?? response ?? null;
    },
    {
      enabled: !!rolId,
      retry: 0,
      refetchOnWindowFocus: false,
      onError: () => {
        notification["error"]({ message: "Error al obtener permisos del rol" });
      },
    }
  );
};

export const useAsignarPermisos = () => {
  return useMutation(async (data) => await POST(data, "permiso/asignarPermisos"), {
    onSuccess: () => {
      notification["success"]({ message: "Permisos asignados correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al asignar permisos" });
      }
    },
  });
};

export const useCrearPermiso = () => {
  return useMutation(async (data) => await POST(data, "permiso/crearPermiso"), {
    onSuccess: () => {
      notification["success"]({ message: "Permiso creado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al crear permiso" });
      }
    },
  });
};

export const useEditarPermiso = () => {
  return useMutation(async (data) => await POST(data, "permiso/editarPermiso"), {
    onSuccess: () => {
      notification["success"]({ message: "Permiso editado correctamente" });
    },
    onError: (error) => {
      if (error.response && error.response.data?.datos) {
        notification["error"]({ message: error.response.data.datos });
      } else {
        notification["error"]({ message: "Error al editar permiso" });
      }
    },
  });
};

// ============= EXPORT DELETE HOOKS =============
export {
  useEliminarPokemon,
  useEliminarLogro,
  useEliminarRequerimientoEvolucion,
  useEliminarZona,
  useEliminarObjeto,
  useEliminarTipoImagen,
  useEliminarRol,
  useEliminarGachapon,
  useEliminarPermiso
} from './useDeleteHooks';
